export enum RoadExitRequestType {
  New = 0,
  Reconstruction = 1
}
